<template>
    <div class="fullscreen bg_land">
        <div class="logo"></div>
        <div class="menu" @click="showFullSwiper"></div>
        <header>
            <h1 class="title">房企拿地监控系统</h1>
            <p class="title--sub" v-if="timeGroup">数据统计时间：{{timeGroup[0]}}-{{timeGroup[1]}}</p>
        </header>
        
        <div class="main flex_justify_between">
            <div class="main--left">
                <div class="box_cutAngle--bg mb_15">
                    <p class="box_cutAngle_title c_pointer" @click="labelClick('normal')">房企拿地属性占比</p>
                    <div class="box_cutAngle_splitline"></div>
                    <div class="flex_justify_between">
                        <div class="pieChartBox" v-if="landType">
                            <Echarts :options="getOptions('pie',landType)"></Echarts>
                        </div>
                        <ul class="pieChartList" v-if="landType && landType.series" >
                            <li class="item" v-for="(item,index) in landType.series.data" :key="index">
                                <span class="label">{{item.name}}</span>
                                <span class="value">{{item.pro}}%</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="box_cutAngle--bg mb_15">
                    <p class="box_cutAngle_title">
                        本周房企拿地<span class="strong">TOP10</span><span class="unit">({{landBarUnit}})</span>
                    </p>
                    <div class="box_cutAngle_splitline"></div>
                    <SwiperList
                        theme="yellow"
                        :hasInnerSplit="true"
                        :hasValue="true"
                        iconType="arrow"
                        iconPosition="before"
                        labelType="longLabel"
                        :perBaseData="landBarTotal"
                        :showData="getlandBarData"
                        @labelClick="(name)=>labelClick('company',name)">
                    </SwiperList>
                    <!-- <ul class="progressbarList mt_5">
                        <li class="item" v-for="(item,index) in getlandBarData" :key="index">
                            <div class="label">{{item.name}}</div>
                            <div class="valueBar flex_align">
                                <div class="innerBar" :style="{'width':item.value/landBarTotal * 100+'%'}">
                                    <div class="innerSplit"></div>
                                </div>
                                {{item.value}}
                            </div>
                            <div class="value">
                                <i class="iconfont" :class="{
                                    'icon-iconfont_up1':item.status=='up',
                                    'icon-iconfont_down':item.status=='down',
                                }"></i>
                                {{item.changeValue}}
                            </div>
                        </li>
                    </ul> -->
                </div>
                <div class="box_cutAngle--bg">
                    <p class="box_cutAngle_title">
                        土地出让幅数<span class="strong">TOP10</span>城市<span class="unit">({{citySellTopUnit}})</span>
                    </p>
                    <div class="box_cutAngle_splitline"></div>
                    <SwiperList
                        theme="blue"
                        :hasInnerSplit="false"
                        :hasValue="false"
                        :perBaseData="citySellTopTotal"
                        :showData="landTransferBarData"
                        @labelClick="(name)=>labelClick('city',name)">
                    </SwiperList>
                    <!-- <ul class="progressbarList mt_5">
                        <li class="item" v-for="(item,index) in landTransferBarData" :key="index">
                            <div class="label">{{item.name}}</div>
                            <div class="valueBar broadBar flex_wrap">
                                <div class="innerBar blue" :style="{'width':item.value/citySellTopTotal * 100+'%'}">{{item.value}}</div>
                            </div>
                        </li>
                    </ul> -->
                </div>
            </div>
            <div class="main--middle">
                <div class="box_chart--doubleLine subscript right_bottom mb_15">
                    <div class="detailBox">
                        <div class="item">
                            <p class="label">土地成交建面(万㎡)</p>
                            <p v-if="landDetail">
                                <span class="value c_land2">{{landDetail.Area}}</span>
                                <span class="ratio">环比 {{landDetail.AreaRound}}%</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':landDetail.AreaRoundType=='2'}">
                                </i>
                            </p>
                        </div>
                        <div class="item">
                            <p class="label">土地成交价格(万元)</p>
                            <p v-if="landDetail">
                                <span class="value c_land1">{{landDetail.Price}}</span>
                                <span class="ratio">环比 {{landDetail.PriceRound}}%</span>
                                <i
                                    class="iconfont icon-iconfont_up"
                                    :class="{'icon-iconfont_down1':landDetail.PriceRoundType=='2'}">
                                </i>
                            </p>
                        </div>
                    </div>
                    <div class="chartsBox">
                        <Echarts v-if="landDetailChart" :options="getOptions('base',landDetailChart)"></Echarts>
                    </div>
                </div>
                <div class="box_map subscript right_bottom">
                    <div class="mapTitle">房企拿地分布</div>
                    <!-- 地图 -->
                    <div class="map-main" ref="zfyxMap">

                    </div>
                    <!-- 地图柱状缩略图 -->
                    <div class="map-chart">
                        <Echarts ref="mapBar" v-if="mapBarData" :options="getOptions('mapBar',mapBarData)" @chartClick="mapBarClick($event)"></Echarts>
                    </div>

                </div>
            </div>
            <div class="main--right">
                <div class="box_cutAngle--bg mb_15"  style="overflow:auto">
                    <p class="box_cutAngle_title fs_18 c_pointer" @click="labelClick('normal')">最新土地成交</p>
                    <div class="tableList land_transaction">
                        <div class="item head">
                            <div class="cell">土地名称</div>
                            <div class="cell">受让方</div>
                            <div class="cell">成交时间</div>
                        </div>
                        <div class="tableList_main tableListHeight" v-if="landTransactionData">
                            <ScrollBox :num='landTransactionData.length'>
                                <ul slot="main">
                                    <li class="item c_pointer" v-for="(item,index) in landTransactionData" :key="index" @click="toDetail(item.id)">
                                        <div class="cell" :title="item.name">
                                            {{item.name}}
                                            <!-- <span class="hasIcon">{{item.name}}</span>
                                            <i v-if="item.isNew" class="iconfont icon-iconfont_new c_new"></i> -->
                                        </div>
                                        <div class="cell" :title="item.Transferee">{{item.Transferee}}</div>
                                        <div class="cell">{{item.time}}</div>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <!-- <ul class="tableList_main" v-if="landTransactionData">
                            <li class="item" v-for="(item,index) in landTransactionData" :key="index">
                                <div class="cell">
                                    {{item.name}}
                                    <i v-if="item.isNew" class="iconfont icon-iconfont_new c_new"></i>
                                </div>
                                <div class="cell">{{item.Transferee}}</div>
                                <div class="cell">{{item.time}}</div>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="box_cutAngle--bg mb_15" style="overflow:auto">
                    <p class="box_cutAngle_title c_pointer" @click="labelClick('company','100')">
                        <span class="strong">TOP100</span>房企本周拿地
                    </p>
                    <div class="tableList land_getLand">
                        <div class="item head">
                            <div class="cell">房企名</div>
                            <div class="cell">土地名称</div>
                            <div class="cell">成交总价(万元)</div>
                        </div>
                        <div class="tableList_main tableListHeight" v-if="landTop100">
                            <ScrollBox :num='landTop100.length'>
                                <ul slot="main">
                                    <li class="item c_pointer" v-for="(item,index) in landTop100" :key="index" @click="toDetail(item.id)">
                                        <div class="cell">{{item.companyName}}</div>
                                        <div class="cell" :title="item.landName">{{item.landName}}</div>
                                        <div class="cell">{{item.price}}</div>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <!-- <ul class="tableList_main" v-if="landTop100">
                            <li class="item" v-for="(item,index) in landTop100" :key="index">
                                <div class="cell">{{item.companyName}}</div>
                                <div class="cell">{{item.landName}}</div>
                                <div class="cell">{{item.price}}</div>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="box_cutAngle--bg">
                    <p class="box_cutAngle_title">
                        出让面积<span class="strong">TOP10</span>城市
                    </p>
                    <div class="box_cutAngle_splitline type2"></div>
                    <div class="box-chart--ladderBar">
                        <Echarts v-if="sellArea" :options="getOptions('ladderBar',sellArea)" @chartClick="chartClick"></Echarts>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import getCharts from "@/utils/getCharts.js";
import api from "@/server/api.js";
import echarts from 'echarts/lib/echarts'
import Util from '@/utils/Util';
import permission from "@/mixins/permission.js";
import { loadAmap, createFullscreenAmap, createCountryDistrictLayer, bd09ToGcj02 } from "@/utils/amapCommon.js";
window.__Echarts = echarts
// const dpr = window.devicePixelRatio;
const dpr = Util.setDpr();
const LAND_MAP_CENTER = [104.195397, 35.86166];
const LAND_MAP_ZOOM = 16.8;
// console.log(dpr)
export default {
    mixins:[permission],
    data(){
        return {
            mapStyle: 'land', // 使用土地系统专属地图样式
            map: null,
            AMap: null,
            districtLayer: null,
            richMarker: null,
            landPolygons: [],
            isMapReady: false,
            mapCenter: LAND_MAP_CENTER,
            getlandBarData:[],//房企拿地TOP10 data
            landBarTotal:0,//房企拿地TOP10 最大值
            landBarUnit:'',//房企拿地TOP10 单位
            landTransferBarData:null,//土地出让幅数 data
            citySellTopTotal:null,//土地出让幅数 最大值
            citySellTopUnit:'',//土地出让幅数 单位
            landTransactionData:null, //最新土地成交 data
            mapBarData:null,//地图柱状缩略图
            mapBarDataMax: 0,
            currentMapInfo:null,
            currentCity:null,
            landList:[],
            timeGroup:null,//统计时间段
            landType:null,//房企拿地属性占比
            landDetail:null,//土地统计(折柱图)
            landDetailChart:null,
            landTop100:null,
            sellArea:null,

        }
    },
    components: {
        Echarts,
    },
    created(){
        this.getInitData();
        document.title="房企拿地监控系统 - 优采大数据"
    },
    mounted() {
        this.initAmap();
    },
    beforeDestroy() {
        clearInterval(this.MapTimmer);
        this.destroyMap();
    },
    methods: {
        async initAmap() {
            try {
                const AMap = await loadAmap({
                    plugins: ['AMap.Scale'],
                });

                if (this._isDestroyed || this._isBeingDestroyed || !this.$refs.zfyxMap) {
                    return;
                }

                this.AMap = AMap;
                this.map = createFullscreenAmap(AMap, this.$refs.zfyxMap, {
                    center: this.mapCenter,
                    zoom: LAND_MAP_ZOOM,
                });
                this.drawAllProvinceBoundaries();
                this.isMapReady = true;
                this.tryRenderLandMap();
            } catch (error) {
                console.error('高德地图初始化失败', error);
            }
        },
        destroyMap() {
            this.clearLandOverlays();

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = null;
            this.isMapReady = false;

            if (this.map) {
                this.map.destroy();
            }

            this.map = null;
            this.AMap = null;
        },
        drawAllProvinceBoundaries() {
            if (!this.AMap || !this.map) {
                return;
            }

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = createCountryDistrictLayer(this.AMap, this.map, {
                'nation-stroke': 'rgba(6, 104, 186, 0.55)',
                'coastline-stroke': 'rgba(6, 104, 186, 0.55)',
                'province-stroke': 'rgba(6, 104, 186, 0.35)',
                fill: 'rgba(6, 104, 186, 0.05)',
            });
        },
        tryRenderLandMap() {
            if (!this.isMapReady || !this.landList.length) {
                return;
            }
            this.drawPolygonAndRichMark(this.landList);
        },
        parsePoint(rawPoint) {
            if (!rawPoint) {
                return null;
            }

            let lng;
            let lat;

            if (Array.isArray(rawPoint)) {
                lng = parseFloat(rawPoint[0]);
                lat = parseFloat(rawPoint[1]);
            } else if (typeof rawPoint === 'string') {
                const pointArr = rawPoint.split(',');
                lng = parseFloat(pointArr[0]);
                lat = parseFloat(pointArr[1]);
            } else if (typeof rawPoint === 'object') {
                lng = parseFloat(rawPoint.lng || rawPoint.longitude);
                lat = parseFloat(rawPoint.lat || rawPoint.latitude);
            }

            if (isNaN(lng) || isNaN(lat)) {
                return null;
            }

            return bd09ToGcj02(lng, lat);
        },
        parseBoundary(boundary) {
            if (!boundary) {
                return [];
            }

            return boundary.split(';').map(item => {
                const pointArr = item.split(',');
                if (pointArr.length < 2) {
                    return null;
                }

                const lng = parseFloat(pointArr[0]);
                const lat = parseFloat(pointArr[1]);

                if (isNaN(lng) || isNaN(lat)) {
                    return null;
                }

                return bd09ToGcj02(lng, lat);
            }).filter(item => {
                return !!item;
            });
        },
        clearLandOverlays() {
            if (this.map && this.landPolygons.length) {
                this.map.remove(this.landPolygons);
            }

            if (this.map && this.richMarker) {
                this.map.remove(this.richMarker);
            }

            if (this.map) {
                this.map.clearInfoWindow();
            }

            this.landPolygons = [];
            this.richMarker = null;
        },
        showFullSwiper(){
            this.$emit('showFullSwiper');
        },
        getOptions(echartType,obj) {
            switch (echartType) {
                case 'pie':
                    let pieoption = getCharts.getPieEchart(obj);
                    return pieoption;
                    break;
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                case 'ladderBar':
                    let ladderbaroption = getCharts.getLadderBarEchart(obj);
                    return ladderbaroption;
                    break;
                case 'mapBar':
                    let mapBarOption = getCharts.getMapBarEchart(obj,this.mapBarDataMax);
                    return mapBarOption;
                    break;
                default:
                    break;
            }
        },
        /** 地图缩略图表增加click事件 */
        mapBarClick(params){
            let _city = this.mapBarData.filter(e => {
                return e.name == params.name ;
            })[0];

            let _arr = [] ;
            if(_city && _city.aList){
                _city.aList.forEach(e => {
                    if(!!e.sLocation ){
                        _arr.push({
                            boundary:e.sLocation,
                            name:e.LandCaption,
                            invisor:e.Invisor,
                            coversArea:e.OccupyArea+'㎡',
                            salesPrice:e.Price + '万元',
                            center:e.sCenter,
                            SolutionID:e.SolutionID,
                        });
                    }
                })
            }
            this.drawPolygonAndRichMark(_arr);
        },
        drawPolygonAndRichMark(_array){
            if (!this.map || !this.AMap) {
                return;
            }

            this.clearLandOverlays();
            let _polygon = [] ;
            _array.forEach(elem => {
                if(!!elem.boundary ){
                    let el = this.drawPolygon(elem,{'click':()=>{
                        this.clickPolygon(elem);
                    }});
                    if (el) {
                        _polygon.push(el);
                    }
                }
            });
            this.landPolygons = _polygon;

            let _index = 0 ;

            clearInterval(this.MapTimmer);
            if(_array.length > 0){
                this.resetRichMark(_array[0]);
                _index ++ ;
                this.MapTimmer = setInterval( () => {
                    if(_index == _array.length ){
                        _index  =  0 
                    }
                    if(_array.length != 0){
                        this.resetRichMark(_array[_index]);
                    }else {
                        clearInterval(this.MapTimmer );
                    }
                    _index ++ ;
                },5000);
            }
          
        },
        drawPolygon(item, events = {}) {
            const path = this.parseBoundary(item.boundary);
            if (path.length < 3 || !this.AMap || !this.map) {
                return null;
            }

            const polygon = new this.AMap.Polygon({
                path: path,
                fillColor: "#FFCC02",
                fillOpacity: 0.6,
                strokeOpacity: 1,
                strokeWeight: 2,
                strokeColor: "#FFCC02",
                zIndex: 120,
            });

            this.map.add(polygon);

            Object.keys(events).forEach(keyName => {
                if (events[keyName]) {
                    polygon.on(keyName, events[keyName]);
                }
            });

            return polygon;
        },
        resetRichMark(elem){
            if (!this.AMap || !this.map) {
                return;
            }

            const point = this.parsePoint(elem.center);
            if (!point) {
                return;
            }

            if (this.richMarker) {
                this.map.remove(this.richMarker);
            }

            this.richMarker = new this.AMap.Marker({
                position: point,
                content: this.getOverlayHtml(elem),
                offset: new this.AMap.Pixel(0, 0),
                zIndex: 300,
            });
            this.richMarker.on('click', () => {
                this.toDetail(elem.SolutionID);
            });

            this.map.add(this.richMarker);
            this.map.panTo(point);
        },
        clickPolygon(elem){
            clearInterval(this.MapTimmer);
            this.resetRichMark(elem);
        },
        getOverlayHtml(currentMapInfo){
           return `<div class="amap-land-overlay-marker">
                        <div class="overlay--details">
                            <div class="od-info">
                                <div class="od-title">${currentMapInfo.name}</div>
                                <div class="items">
                                    <div class="label">受让方：</div>
                                    <div class="value" title="${currentMapInfo.invisor}">${currentMapInfo.invisor}</div>
                                </div>
                                <div class="items">
                                    <div class="label">占地面积：</div>
                                    <div class="value">${currentMapInfo.coversArea}</div>
                                </div>
                                <div class="items">
                                    <div class="label">成交金额：</div>
                                    <div class="value">${currentMapInfo.salesPrice}</div>
                                </div>
                            </div>
                            <div class="od-point"></div>
                            <div class="line-45">
                                <div class="ins"></div>
                            </div>
                        </div>
                    </div>`
        },
        getInitData(){
            // 统计时间段
            api.getLandTime().then(res => {
                if(!res.ErrorCode){
                    this.timeGroup = res.Data;
                }
            });
            
            // 房企拿地属性占比
            api.getLandType().then(res => {
                // console.log('房企拿地属性占比',res)
                if(!res.ErrorCode){
                    let _landType = {
                        series:{
                            name:'房企拿地属性占比',
                            center: ['46%', '50%'],
                            radius: ['22%', '48%'],
                            data:[],
                            label: {
                                normal: {
                                    show: true,
                                    formatter(param){
                                        return [
                                            '{value|'+res.Data[param.dataIndex].Pro+'}{unit|%}',
                                            '{label|'+param.name+'}',
                                        ].join('\n')
                                    },
                                    position: 'outside',
                                    fontSize: 10 * dpr,
                                    rich: {
                                        value: {
                                            fontSize: 15 * dpr,
                                            fontWeight:'bold'
                                        },
                                        unit: {
                                            fontSize: 10 * dpr,
                                        },
                                        label: {
                                            fontSize: 10 * dpr,
                                            color: '#fff'
                                        }
                                    }
                                },
                            },
                        },
                        tooltip:{
                            formatter: function(param) {
                                // console.log(param)
                                let title = `<span class="fs_12 c_fff">${param.name}</span>`
                                let percent = `<span class="fs_12 c_fff">
                                                    占比
                                                    <span class="fs_16 fw_b">${res.Data[param.dataIndex].Pro}</span>%
                                                </span>`
                                let value = `<span class="fs_12 c_fff">
                                                    拿地
                                                    <span class="fs_16 fw_b">${param.value}</span>幅
                                                </span>`
                                
                                return param.marker + title + '<br />' + percent + '<br />' + value
                                    
                            },
                        }
                    }
                    _landType.series.data = res.Data.map( e=> {
                        return {
                            name:e.UseTypeTag,
                            value:Number(e.count),
                            pro: Number(e.Pro)
                        }
                    })
                    // this.landType = _landType;
                    this.landType = _landType;
                }
            });

            // 土地成交状况(折柱图)
            api.getLandTransStatus().then(res => {
                console.log('土地成交状况',res)
                if(!res.ErrorCode){
                   this.landDetail = res.Data.landCount;
                   this.landDetailChart = {//成交价格、成交面积趋势(折柱图)
                        yAxisNum:2,
                        color:['#E7C531','#42B7F4'],
                        xAxis:{
                            // boundaryGap: true,
                            data: res.Data.landTraData.map( e => { return e.sTime})
                        },
                        grid: {
                            left: '5%',
                            right: '5%',
                        },
                        unit:['万㎡','万元'],
                        series:[
                            {
                                name: '成交建面',
                                type: 'line',
                                smooth: true, //是否平滑曲线显示
                                symbolSize:0,
                                lineStyle: {
                                    width:2*dpr,
                                    color:'rgba(32, 145, 201, 1)'
                                },
                                areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new __Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0,  color: 'rgba(32, 145, 201, 1)'}, 
                                            { offset: 1,  color: 'rgba(32, 145, 201, 0)'}
                                        ], false),
                    
                                    }
                                },
                                data: res.Data.landTraData.map( e => { return e.Area})
                            },
                            {
                                name: '成交价格',
                                type: 'line',
                                smooth: true, //是否平滑曲线显示
                                symbolSize:0,
                                yAxisIndex:1,
                                lineStyle: {
                                    width:2*dpr,
                                    color:'rgba(210, 177, 25, 1)'
                                },
                                areaStyle: { //区域填充样式
                                    normal: {
                                        //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                        color: new __Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            { offset: 0,  color: 'rgba(210, 177, 25, 1)'}, 
                                            { offset: 1,  color: 'rgba(210, 177, 25, 0.2)'}
                                        ], false),
                                    },
                                },
                                data:res.Data.landTraData.map( e => { return e.Price})
                            },
                        ]
                    }

                    //chartEnd
                }
            });

            //最新土地成交
            api.getLandTranData().then(res => {
                // console.log('最新土地成交',res)
                if(!res.ErrorCode){
                    this.landTransactionData = res.Data.map(e => {
                        return  {
                            name:e.LandCaption,
                            Transferee:e.Invisor,
                            time:e.ChangeDateTime,
                            id:e.SolutionID,
                            isNew:e.isTrue
                        }
                    });
                }
            });

            //房企拿地TOP10
            api.takeLandTop().then(res => {
                // console.log('房企拿地TOP10',res)
                if(!res.ErrorCode){
                    this.getlandBarData = res.Data.TakeLandTop
                    this.landBarUnit = res.Data.sUnit ;
                    this.landBarTotal = res.Data.AllArea ;
                }
            });

            //房企本周拿地 top100
            api.getLandTopHun().then(res =>{
                // console.log('房企本周拿地 top100',res)
                if(!res.ErrorCode){
                    this.landTop100 = res.Data.map(e => {
                        return {
                            companyName:e.Company,
                            landName:e.LandCaption,
                            price:e.Price,
                            id:e.SolutionID,
                        }
                    });
                }
            });

            //出让土地面积TOP10
            api.getLandSaleAreaTen().then(res => {
                // console.log('出让土地面积TOP10',res)
                if(!res.ErrorCode){
                    this.sellArea  = res.Data
                }
            });

            //土地出让幅数 top10
            api.getlandSaleFrame().then(res => {
                // console.log('土地出让幅数TOP10',res)
                if(!res.ErrorCode){
                    this.landTransferBarData = res.Data.data
                    this.citySellTopUnit = res.Data.sUnit ;
                    this.citySellTopTotal = res.Data.AllArea;
                }
            });

            //mapBarData地图城市数据
            api.getLandCityDetail().then(res => {
                // console.log('mapBarData地图城市数据',res)
                 if(!res.ErrorCode){
                     
                    this.mapBarData = res.Data.map( e => {
                        return {
                            name: e.CityCaption,
                            value: e.count,
                            aList: e.aList
                        }
                     });

                     this.mapBarDataMax = Math.max(...res.Data.map(e => {
                         return e.count 
                     }));

                    this.landList = [] ;

                     this.mapBarData.forEach(el => {
                         el.aList.forEach(e => {
                             if(!!e.sLocation ){
                                this.landList.push({
                                    boundary:e.sLocation,
                                    name:e.LandCaption,
                                    invisor:e.Invisor,
                                    coversArea:e.OccupyArea+'㎡',
                                    salesPrice:e.Price + '万元',
                                    center:e.sCenter,
                                    SolutionID:e.SolutionID,
                                });
                             }
                         })
                     })

                    this.$nextTick(() => {
                        this.tryRenderLandMap();
                    })

                 }
            });
        },
        // 详情跳转
        toDetail(id){
            if(this.userType==1){
                this.showTip();
                return
            }
            let routeData = this.$router.resolve({
                path: '/page/detail',
                query:{
                    module:1,  
                    type:1,  
                    id:id,  
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
        },
        // topList 点击跳转=>列表
        labelClick(type,name=''){
            console.log('labelClick',type,name)
            let reg = /[^\d]+/g;
            let _dataRange = this.timeGroup.map(e=>{
                return e.replace(reg, "-").substring(0,e.length-1);
            })
            let routeData = this.$router.resolve({
                path: '/page/land',
                query:{
                    startDate:_dataRange[0],
                    endDate:_dataRange[1],
                    type:type,
                    name:name
                }
            });
	        window.open(routeData.href, this.isScreen?'_self':'_blank');
        },
        // 图表点击
        chartClick(param){
            console.log(param)
            this.labelClick('city',param.name)
        }
    },
}
</script>
<style lang="scss" scoped>
@use '../../assets/styles/mixin' as *;

.logo{ background-image: url('../../assets/imgs/logo_land.png');}
header{
    height: 10vh;
    box-sizing: border-box;
    padding-top: 2.4vh;
    text-align: center;
    .title{
        font-size:.36rem;
        font-weight: bold;
        @include text_gradient(top,#FFFFFF,#00A1FF);
    }
    .title--sub{
        font-size:.18rem;
        color: #fff;
        line-height: 2;
    }
}

.box_map{
    padding: 0 .03rem;
}
.mapTitle{
    position: absolute;
    font-size: .3rem;
    font-weight: bold;
    @include text_gradient(top,#FFFFFF,#00A1FF);
    position: absolute;
    left: .35rem;
    top: .3rem;
    z-index: 10;
}
.map-main {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    :deep(.amap-land-overlay-marker) {
        position: relative;
        width: 0;
        height: 0;
        overflow: visible;
        cursor: pointer;
    }
    :deep(.amap-land-overlay-marker .overlay--details) {
        pointer-events: auto;
    }
}

.map-chart {
    position: absolute;
    width: 30%;
    height: 41%;
    background:#000;
    border:2px solid rgba(6, 104, 186, 0.5);
    bottom: 0.1rem;
    right: 0.1rem;
    z-index: 10;
    pointer-events: auto;
}

.tableListHeight{
    height: 18vh;
}


</style>
